import { format } from "date-fns";

/*
 * Takes in raw course data formated based on LWC's original format.
 *  - See src/tempData/myCourses.json for an example.
 * Returns array of object based on format below.
 *
 * This will obviously need adjustment, or can possibly be removed, depending
 * on how we format the data in the new app, and whether we need to support
 * data with the older structure.
 */
export const getSimplifiedCourseData = (originalData) => {
	const newData = originalData.map((course) => {
		const startingHour = String(course.startHH).padStart(2, "0");
		const startingMinutes = String(course.startMM).padStart(2, "0");
		const date = new Date(`${course.classDate}T${startingHour}:${startingMinutes}`);
		const month = format(date, "MMMM");
		const [day, year] = [date.getDate(), date.getFullYear()];
		const [hour, minutes] = [date.getHours(), String(date.getMinutes()).padStart(2, "0")];

		let location = "";
		switch (course.locID) {
		case "215":
			location = "Fairfax Location";
			break;
		default:
			location = "Check with Organizers";
			break;
		}
		return {
			cancelLink: "#",
			date: `${month} ${day}, ${year}`,
			description: course.classFullDescription,
			id: course.classID,
			location,
			moreInfoLink: "#",
			rawDate: date,
			time: `${hour}:${minutes} ${course.startAMPM}`,
			title: course.className
		};
	});

	newData.sort((first, second) => first.rawDate - second.rawDate);

	return newData;
};
